import { uploadFileToObs as uploadFileToObsWidgets } from '@meitu/xdesign-widgets/dist/uploadManager';

/**
 * 上传 Base64 到 OBS
 *
 * @param base64 - Base 64 编码
 */
export const uploadBase64ToObs = async (base64: string, fileKey?: string) => {
    return uploadFileToObs(base64, fileKey);
};

/**
 * 上传文件到 OBS
 *
 * - TODO：现在先直接转发到widgets做统一上传。业务转干净后这个再去掉
 *
 * @param fileData - 文件数据
 * @param fileKey - 可选；自定义文件 Key
 * @param aloneType - 可选；MAAT type 类型
 * @param customSuffix - 可选；自定义后缀
 */
export const uploadFileToObs = async (
    fileData: string | File,
    fileKey?: string,
    aloneType?: string, // 用来覆盖全局的type
    customSuffix?: string,
): Promise<{ url: string; previewUrl?: string }> => {
    const { url, previewUrl } = await uploadFileToObsWidgets(fileData, {
        customMaatType: aloneType,
        customFileKey: fileKey,
        customSuffix: customSuffix,
    });
    return {
        url,
        previewUrl,
    };
};
